import { render, staticRenderFns } from "./StockTextPopularItem.vue?vue&type=template&id=187cf250"
import script from "./StockTextPopularItem.vue?vue&type=script&lang=js"
export * from "./StockTextPopularItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports